/**
 * select.js
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';


export default function Select(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    options,
    defaultValue,
    onChange: onChangeProp,
    ...rest
  } = props;
  
  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;

  
  return (
    <Controller
      control={formContext.control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { ref, value, onChange, ...inputProps } }) => {
        return (
          <select
            value={value}
            onChange={e => {
              const value = e.target.value;
              onChange(value)
              if (onChangeProp) onChangeProp(e, value);              
            }}
            {...rest}
          >
            {options.map(o => (
              <option key={o.id} value={o.value}>{o.label}</option>
            ))}
          </select>
        );
      }}
    />
  );
}